import { Vector2 } from '@babylonjs/core/Maths/math';
import { TransformNode } from '@babylonjs/core/Meshes/transformNode';

import { MeshSystem } from '../System/meshSystem';

export class PositionEntity {

    public key: string;
    protected system: MeshSystem;
    
    constructor(type:string, system: MeshSystem) {
        this.system = system;
        
        this.key = type + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        this.addTransformMesh();
    }

    protected transformMesh: TransformNode;
    private addTransformMesh() {
        this.transformMesh = new TransformNode(this.key, this.system.scene);
    }
    
    public position = Vector2.Zero();
    protected _setPosition(pos: Vector2) {
        this.position = pos;
    }
    
    public size = 1;
    protected _setSize(size: number) {
        this.size = size;
    }

    public setSize(size: number) {
        this._setSize(size);
        this.setTransformMeshSize(size);
    }

    public setTransformMeshSize(size: number) {
        this.transformMesh.scaling.x = size;
        this.transformMesh.scaling.y = size;
        this.transformMesh.scaling.z = size;
    }

    public setPosition(pos: Vector2) {
        this._setPosition(pos);
        this.transformMesh.position.x = pos.x;
        this.transformMesh.position.z = pos.y;
        this.transformMesh.position.y = 1;
    }

    public setRotation(rot: number) {
        this.transformMesh.rotation.y = rot;
    }
}